import React from 'react';
import * as S from './styles';

type Props = {
  className?: string;
  dataBotify?: string;
  displayOptions?: React.ReactNode;
  sortOptions: React.ReactNode;
  subtitle?: string;
  title?: string;
};

const HeaderRow = (props: Props) => {
  const {
    className,
    dataBotify,
    displayOptions,
    sortOptions,
    subtitle,
    title,
  } = props;

  return (
    <S.HeaderRow className={className} data-test="ProductsHeader">
      {title || subtitle ? (
        <S.TitleWrapper data-test="ProductsHeaderTitleWrapper">
          {title && <S.Title data-botify={dataBotify}>{title}</S.Title>}
          {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
        </S.TitleWrapper>
      ) : null}
      {sortOptions ? <>{sortOptions}</> : null}

      {displayOptions ? (
        <S.DisplayOptions>{displayOptions}</S.DisplayOptions>
      ) : null}
    </S.HeaderRow>
  );
};

export default HeaderRow;
